import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

// import VConsole from "vconsole"; //import vconsole
// let vConsole = new VConsole() // 初始化
import 'normalize.css/normalize.css';
import framework from './a.framework';
Vue.use(framework, {
  //href: 'http://ma6.beijingapm.top',
  platform: 'mobile',
  handler({ code, msg, data }: any) {
    if (code == 81003) {
			/* this.$alert(msg + '<br>点击确定回到上一个页面!', '提示', {
				dangerouslyUseHTMLString: true,
				callback:
					(action: string) => {
						if (action == 'confirm') {
							window.location.href =
								this.$env.env == 'proj.production'
									? 'http://portal.beijingapm.top/'
									: 'http://172.21.32.64:82/test/newPortal/dist/';
							return false;
						}
					},
			}); */
    }
  },
});

Vue.config.productionTip = false;

Vue.prototype.$vanItemHeight = (window as any).hotcss.dpr * 44;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
